export default "__VITE_ASSET__7ac46e1c__"